export default "__VITE_ASSET__CbfD$2Os__"